module.exports = __webpack_public_path__ + "02_mustache_grey.c339b750.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/papa/layer3/02_mustache_grey.png
// module id = 41QZ
// module chunks = 0